<template>
  <div>
    <nav-bar/>
    <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow">
      <ul class="nav flex-column">
        <li class="nav-item" id="current">
          <a class="nav-link navbar-text pull-left" href="#/OrderPending">{{$t('OrderPending.sidebar.pending')}}</a>
          <span v-if="orders.length > 0" class="pull-right badge badge-default">{{ orders.length }}</span>
        </li>
        <li class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#/OrderCurrent">{{$t('OrderPending.sidebar.current')}}</a>
        </li>
      </ul>
      <button id="addOrder" class="btn btn-kne-orange col-12 mt-3" @click="addOrderAction()">
        <i class="fa fa-plus-circle fa-lg" aria-hidden="true"></i>
        {{$t('OrderPending.sidebar.add_order')}}
      </button>
    </div>
    <div class="view">
      <div class="card">
        <div class="card-header">
          <h3 class="my-2">{{$t('OrderPending.title')}}</h3>
        </div>
        <div class="table-responsive">
          <table class="table table-hover font-grey mb-0 table-sm">
            <thead class="bg-darkgrey">
              <tr>
                <th @click="sortBy('numRef', false)" class="sortable nowrap">{{$t('OrderPending.ref')}}<i v-if="sort.current === 'numRef'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <!-- <th v-if="hasIntegration" @click="sortBy('isDivisionX', false)" class="sortable nowrap">{{$t('OrderCurrent.isDivisionX')}}<i v-if="sort.current === 'isDivisionX'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th> -->
                <th @click="sortBy('vin', false)" class="sortable nowrap">{{$t('OrderPending.VIN')}}<i v-if="sort.current === 'vin'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('source', false)" class="sortable nowrap">{{$t('OrderPending.source')}}<i v-if="sort.current === 'source'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('creationDate', false)" class="sortable nowrap">{{$t('OrderCurrent.date')}}<i v-if="sort.current === 'creationDate'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('transmitterName', false)" class="sortable nowrap">{{$t('OrderCurrent.pickup')}}<i v-if="sort.current === 'transmitterName'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('receiverName', false)" class="sortable nowrap">{{$t('OrderCurrent.delivery')}}<i v-if="sort.current === 'receiverName'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('payerName', false)" class="sortable nowrap">{{$t('OrderCurrent.billing')}}<i v-if="sort.current === 'payerName'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th></th>
              </tr>
            </thead>
            <transition-group name="fade" tag="tbody">
              <tr key='filter'>
                <td>
                  <regular-input
                    :value="fields['numRef']"
                    @input="fields['numRef'] = $event; filteredSearchMethod()"
                    :placeholder="$t('OrderPending.ref')"/>
                </td>
                <!-- <td v-if="hasIntegration"></td> -->
                <td>
                  <regular-input
                    :value="fields.vin"
                    @input="fields.vin = $event; filteredSearchMethod()"
                    :placeholder="$t('OrderPending.VIN')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.source"
                    @input="fields.source = $event; filteredSearchMethod()"
                    :placeholder="$t('OrderPending.source')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.creationDate"
                    @input="fields.creationDate = $event; filteredSearchMethod()"
                    :placeholder="$t('OrderCurrent.date')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.transmitterName"
                    @input="fields.transmitterName = $event; filteredSearchMethod()"
                    :placeholder="$t('OrderCurrent.pickup')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.receiverName"
                    @input="fields.receiverName = $event; filteredSearchMethod()"
                    :placeholder="$t('OrderCurrent.delivery')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.payerName"
                    @input="fields.payerName = $event; filteredSearchMethod()"
                    :placeholder="$t('OrderCurrent.billing')"/>
                </td>
                <td colspan="2"></td>
              </tr>
              <tr v-for="order in filterResults" :key="order['.key']">
                <td class="nowrap">{{order.numRef}}</td>
                <!-- <td v-if="hasIntegration" class="nowrap">
                  <i v-if="order.isDivisionX" class="fa fa-check" aria-hidden="true"></i>
                </td> -->
                <td class="nowrap">{{order.vin}}</td>
                <td class="nowrap"><p class="table-fix-width">{{order.source}}</p></td>
                <td class="nowrap">{{ getDate(order.creationDate) }}</td>
                <td class="nowrap"><p class="table-fix-width">{{order.transmitterName}}</p></td>
                <td class="nowrap"><p class="table-fix-width">{{order.receiverName}}</p></td>
                <td class="nowrap"><p class="table-fix-width">{{order.payerName}}</p></td>
                <td>
                  <div class="pull-right" id="action">
                    <button v-if="isSageOne" class="btn btn-kne-orange" :disabled="inProgress === order['.key']" @click="openPrice(order)">
                      <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
                    <button v-else class="btn btn-kne-orange" :disabled="inProgress === order['.key']" @click.once="action(order, true)">
                      <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
                    <button class="ml-2 btn btn-kne-orange" :disabled="inProgress === order['.key']" @click.once="action(order, false)">
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </transition-group>
          </table>
        </div>
      </div>

      <transition name="fade">
        <modal
        v-if="closedModal !== true"
        @close-request="closedModal = true; clear()"
        closable>
          <div class="row">
            <div class="col-12 col-md-6 pr-0" id="Order">
              <h4 class="mx-3 kne-title">{{$t('OrderPending.orderTab.order')}}</h4>
              <div class="">
                <regular-input
                :value="order.source"
                @input="order.source = $event"
                type="text" :placeholder="$t('OrderPending.orderTab.source')" class="col-12 form-group"
                />
              </div>
              <div class="">
                <regular-input
                  :value="order.datePromis"
                  @input="order.datePromis =  $event"
                  type="date" :placeholder="$t('OrderPending.orderTab.datePromis')" class="col-12 form-group"
                />
              </div>
              <div class="">
                <regular-input
                :value="order.numRef"
                @input="order.numRef = $event"
                type="text" :placeholder="$t('OrderPending.orderTab.reference')" class="col-12 form-group"/>
              </div>
              <div class="">
                <regular-input
                :value="order.price"
                @input="order.price = $event"
                type="text" :placeholder="$t('OrderPending.orderTab.price')" class="col-12 form-group"/>
                <regular-textarea
                :value="order.comment"
                @input="order.comment = $event"
                rows="4" :placeholder="$t('OrderPending.orderTab.comment')" class="col-12 form-group"/>
              </div>
            </div>

            <div class="col-12 col-md-6 pl-0" id="vehicle">
              <h4 class="mx-3 kne-title">{{$t('OrderPending.vehicleInfoTab.vehicle_info')}}</h4>
              <div class="col-12">
                <div class="row">
                  <regular-input
                  :value="VIN"
                  @input="VIN = $event"
                  type="text" :placeholder="$t('OrderPending.vehicleInfoTab.VIN')" class="col-12 form-group"
                  />
                  <div class="col-12">
                    <button class="btn btn-kne-orange w-100 form-group" :disabled="VIN === ''" @click="validate(VIN)">{{$t('OrderPending.vehicleInfoTab.validate')}}</button>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <regular-input
                  :value="MAKE"
                  @input="MAKE = $event"
                  type="text" :placeholder="$t('OrderPending.vehicleInfoTab.make')" class="col-12 form-group"/>
                  <regular-input
                  :value="MODEL"
                  @input="MODEL = $event"
                  type="text" :placeholder="$t('OrderPending.vehicleInfoTab.model')" class="col-12 form-group"/>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <regular-input
                  :value="YEAR"
                  @input="YEAR = $event"
                  type="text" :placeholder="$t('OrderPending.vehicleInfoTab.year')" class="col-12 form-group"/>
                  <div class="col-12">
                    <button class="btn btn-kne-orange w-100 form-group" @click="addVehicle()">{{$t('OrderPending.vehicleInfoTab.add_vehicle')}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead class="">
                  <tr>
                    <th></th>
                    <th>{{$t('OrderPending.vehicleInfoTab.VIN')}}</th>
                    <th>{{$t('OrderPending.vehicleInfoTab.year')}}</th>
                    <th>{{$t('OrderPending.vehicleInfoTab.make')}}</th>
                    <th>{{$t('OrderPending.vehicleInfoTab.model')}}</th>
                  </tr>
                </thead>
                <transition-group name="fade" tag="tbody">
                  <tr v-for="(vehicle, index) in vehicles" :key="vehicle.vin+vehicle.year">
                    <td>{{index+1}}</td>
                    <td>{{vehicle.vin}}</td>
                    <td>{{vehicle.year}}</td>
                    <td>{{vehicle.make}}</td>
                    <td>{{vehicle.model}}</td>
                  </tr>
                </transition-group>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="mt-3 col-4 pr-0" id="pickup">
              <h4 class="mx-3 kne-title">{{$t('OrderPending.pickupDeliveryTab.pickup')}}</h4>
              <regular-datalist
              :value="datalist.pickup"
              @input="setAndSearch($event, 'pickup')"
              :originalList="$store.state.allContacts"
              :secondList="addressbook"
              :placeholder="$t('AddressBook.title')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterName"
              @input="order.transmitterName = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterAddress"
              @input="order.transmitterAddress = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterCity"
              @input="order.transmitterCity = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterPostcode"
              @input="order.transmitterPostcode = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterProvince"
              @input="order.transmitterProvince = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterCountry"
              @input="order.transmitterCountry = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterEmail"
              @input="order.transmitterEmail = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterPhone"
              @input="order.transmitterPhone = $event"
              type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterFax"
              @input="order.transmitterFax = $event"
              type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="col-12 form-group"/>
              <regular-input
              :value="order.transmitterContact"
              @input="order.transmitterContact = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="col-12 form-group"/>
              <regular-checkbox
              :checked="pickupSave"
              @change="pickupSave = $event"
              :label="$t('OrderPending.pickupDeliveryTab.save_dealer')" class="col-12"/>
            </div>

            <div class="mt-3 col-4 px-0" id="delivery">
              <h4 class="mx-3 kne-title">{{$t('OrderPending.pickupDeliveryTab.delivery')}}</h4>
              <regular-datalist
              :value="datalist.delivery"
              @input="setAndSearch($event, 'delivery')"
              :originalList="$store.state.allContacts"
              :secondList="addressbook"
              :placeholder="$t('AddressBook.title')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverName"
              @input="order.receiverName = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverAddress"
              @input="order.receiverAddress = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverCity"
              @input="order.receiverCity = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverPostcode"
              @input="order.receiverPostcode = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverProvince"
              @input="order.receiverProvince = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverCountry"
              @input="order.receiverCountry = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverEmail"
              @input="order.receiverEmail = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverPhone"
              @input="order.receiverPhone = $event; onInputBillingSame()"
              type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverFax"
              @input="order.receiverFax = $event; onInputBillingSame()"
              type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="col-12 form-group"/>
              <regular-input
              :value="order.receiverContact"
              @input="order.receiverContact = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="col-12 form-group"/>
              <regular-checkbox
              :checked="deliverySave"
              @change="deliverySave = $event"
              :label="$t('OrderPending.pickupDeliveryTab.save_dealer')" class="col-12"/>
            </div>

            <div class="mt-3 col-4 pl-0" id="billing">
              <h4 class="mx-3 kne-title">{{$t('OrderPending.pickupDeliveryTab.billing')}}</h4>
              <regular-datalist
              :value="datalist.billing"
              @input="setAndSearch($event, 'billing')"
              :disabled="billingSame"
              :originalList="$store.state.allContacts"
              :secondList="isSageOne ? sageIDonly : addressbook"
              :placeholder="$t('AddressBook.title')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerName"
              @input="order.payerName = $event"
              :disabled="billingSame"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="order.payerAddress"
              @input="order.payerAddress = $event"
              :disabled="billingSame"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="order.payerCity"
              @input="order.payerCity = $event"
              :disabled="billingSame"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerPostcode"
              @input="order.payerPostcode = $event"
              :disabled="billingSame"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerProvince"
              @input="order.payerProvince = $event"
              :disabled="billingSame"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerCountry"
              @input="order.payerCountry = $event"
              :disabled="billingSame"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerEmail"
              @input="order.payerEmail = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerPhone"
              @input="order.payerPhone = $event"
              :disabled="billingSame"
              type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerFax"
              @input="order.payerFax = $event"
              :disabled="billingSame"
              type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="col-12 form-group"/>
              <regular-input
              :value="order.payerContact"
              @input="order.payerContact = $event"
              :disabled="billingSame"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="col-12 form-group"/>
              <regular-checkbox
              :checked="billingSame"
              @change="billingSame = $event"
              :label="$t('OrderPending.pickupDeliveryTab.same_as_delivery')" class="col-12"/>
            </div>
          </div>
          <div class="col-12">
            <button class="btn btn-kne-orange w-100" :disabled="!formCompleted" @click="addOrder()">{{$t('OrderPending.submitOrder')}}</button>
          </div>
        </modal>
      </transition>

      <transition name="fade">
        <modal
        v-if="modal.openPrice"
        @close-request="modal.openPrice = false"
        closable>
          <h4 class="mx-3 kne-title">{{$t('OrderPending.orderTab.confirmPrice')}}</h4>
          <div>
            <regular-input
            :value="selected.price"
            @input="selected.price = $event"
            type="number" :placeholder="$t('OrderPending.orderTab.price')" class="col-12 form-group"/>
          </div>
          <div class="">
            <regular-input
              :value="selected.datePromis"
              @input="selected.datePromis =  $event"
              type="date" :placeholder="$t('OrderPending.orderTab.datePromis')" class="col-12 form-group"
            />
          </div>
          <div class="col-12">
            <button class="btn btn-kne-orange w-100" :disabled="selected.price === ''" @click.once="action(selected, true)">{{$t('OrderPending.submitOrder')}}</button>
          </div>
        </modal>
      </transition>


    </div>
  </div>
</template>

<script>
import Modal from '../Modal.vue'
import regularInput from '../regularInput.vue'
import regularCheckbox from '../regularCheckbox.vue'
import regularTextarea from '../regularTextarea.vue'
import Search from '../module/Search.vue'
import {db} from '../../firebase'
import _ from 'lodash'

export default {
  name: 'orderPending',
  components: {
    Modal,
    regularInput,
    regularCheckbox,
    regularTextarea,
    Search
  },
  data () {
    return {
      closedModal: true,
      VIN: '',
      MAKE: '',
      MODEL: '',
      YEAR: '',
      vehicles: [],
      pickupSave: false,
      deliverySave: false,
      billingSame: false,
      inProgress: '',
      modal: {
        openPrice: false
      },
      order: {
        comment: '',
        datePromis: '',
        latitude: 0.001,
        longitude: 0.001,
        make: '',
        model: '',
        nbDispatch: 0,
        numRef: '',
        payer: '',
        payerAddress: '',
        payerCity: '',
        payerContact: '',
        payerFax: '',
        payerName: '',
        payerPhone: '',
        payerEmail: '',
        payerPostcode: '',
        payerCountry: '',
        payerProvince: '',
        price: '',
        receiver: '',
        receiverAddress: '',
        receiverCity: '',
        receiverContact: '',
        receiverFax: '',
        receiverName: '',
        receiverPhone: '',
        receiverEmail: '',
        receiverPostcode: '',
        receiverCountry: '',
        receiverProvince: '',
        status: 'Processing',
        source: '',
        transmitter: '',
        transmitterAddress: '',
        transmitterCity: '',
        transmitterContact: '',
        transmitterFax: '',
        transmitterName: '',
        transmitterPhone: '',
        transmitterEmail: '',
        transmitterPostcode: '',
        transmitterCountry: '',
        transmitterProvince: '',
        transpCigle: '',
        transpName: '',
        vin: '',
        year: ''
      },
      datalist: {
        pickup: '',
        pickupUid: '',
        delivery: '',
        deliveryUid: '',
        billing: '',
        billingUid: ''
      },
      fields: {
        numRef: '',
        vin: '',
        source: '',
        creationDate: '',
        receiverAddress: '',
        transmitterAddress: '',
        payerAddress: ''
      },
      backup: {
        sageIDDelivery: ''
      },
      filterResults: [],
      orders: [],
      sort: {
        current: 'numRef',
        desc: true
      },
      addressbook: [],
      selected: {}
    }
  },
  created () {
    var id = this.companyUID
    this.$bindAsArray('orders', db.ref('database/transporter/' + id + '/unprocessed'), null, () => {
      this.filteredSearchMethod()
    })
  },
  methods: {
    addOrderAction () {
      var id = this.companyUID
      if (this.addressbook.length === 0) {
        console.log('initializing addressbook')
        db.ref('database/transporter/' + id + '/carnet').once('value').then((snap) => {
          let addressbookArray = []
          snap.forEach((element) => {
            let item = element.val()
            item.key = element.key
            addressbookArray.push(item)
          })
          this.addressbook = addressbookArray
        })
      }
      this.closedModal = false
    },
    filteredSearchMethod: _.debounce(function () {
      this.filterResults = []
      this.filterResults = this.orders.filter((entry) => {
        var result = true
        for (var attr in this.fields) {
          if (this.fields[attr] !== '') {
            var reg = this.fields[attr].replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
            var re = new RegExp(reg, 'i')
            if (attr === 'creationDate') {
              let date = this.getDate(entry[attr])
              result = re.test(date)
            } else {
              result = re.test(entry[attr])
            }
          }
          if (result === false) break
        }
        return result
      })
      this.filterResults.reverse()
      this.sortBy(this.sort.current, true)
    }, 100),
    setAndSearch: function (event, section) {
      if (section === 'pickup') {
        this.datalist.pickup = event.value
        this.datalist.pickupUid = event.key
        if (event.key !== null) {
          db.ref('users/dealersList/' + this.datalist.pickupUid).once('value').then((snap) => {
            if (snap.val()) {
              this.order.transmitterName = snap.val().name
              this.order.transmitterAddress = snap.val().address
              this.order.transmitterCity = snap.val().city
              this.order.transmitterPostcode = snap.val().postcode
              this.order.transmitterPhone = snap.val().phone
              this.order.transmitterEmail = snap.val().receptionEmail || ''
              this.order.transmitterFax = snap.val().fax
              this.order.transmitterProvince = snap.val().province
              this.order.transmitterCountry = snap.val().country
            }
            // this.order.transmitterContact = snap.val().contact
          }).catch(function (error) {
            console.log(error)
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.pickupUid) {
              this.order.transmitterName = entry.name
              this.order.transmitterAddress = entry.address
              this.order.transmitterCity = entry.city
              this.order.transmitterPostcode = entry.postcode
              this.order.transmitterPhone = entry.phone
              this.order.transmitterEmail = entry.receptionEmail || ''
              this.order.transmitterFax = entry.fax
              this.order.transmitterProvince = entry.province
              this.order.transmitterCountry = entry.country
            }
          })
        }
      }
      if (section === 'delivery') {
        this.datalist.delivery = event.value
        this.datalist.deliveryUid = event.key
        if (event.key !== null) {
          db.ref('users/dealersList/' + this.datalist.deliveryUid).once('value').then((snap) => {
            if (snap.val()) {
              this.order.receiverName = snap.val().name
              this.order.receiverAddress = snap.val().address
              this.order.receiverCity = snap.val().city
              this.order.receiverPostcode = snap.val().postcode
              this.order.receiverPhone = snap.val().phone
              this.order.receiverEmail = snap.val().receptionEmail || ''
              this.order.receiverFax = snap.val().fax
              this.order.receiverProvince = snap.val().province
              this.order.receiverCountry = snap.val().country
              if (this.billingSame) this.order.sageID = snap.val().sageID
              this.backup.sageIDDelivery = snap.val().sageID
              this.onInputBillingSame()
            }
            // this.order.transmitterContact = snap.val().contact
          }).catch(function (error) {
            console.log(error)
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.deliveryUid) {
              this.order.receiverName = entry.name
              this.order.receiverAddress = entry.address
              this.order.receiverCity = entry.city
              this.order.receiverPostcode = entry.postcode
              this.order.receiverPhone = entry.phone
              this.order.receiverEmail = entry.receptionEmail || ''
              this.order.receiverFax = entry.fax
              this.order.receiverProvince = entry.province
              this.order.receiverCountry = entry.country
              if (this.billingSame) this.order.sageID = entry.sageID
              this.backup.sageIDDelivery = entry.sageID
              this.onInputBillingSame()
            }
          })
        }
      }
      if (section === 'billing') {
        this.datalist.billing = event.value
        this.datalist.billingUid = event.key
        if (event.key !== null) {
          db.ref('users/dealersList/' + this.datalist.billingUid).once('value').then((snap) => {
            if (snap.val()) {
              this.order.payerName = snap.val().name
              this.order.payerAddress = snap.val().address
              this.order.payerCity = snap.val().city
              this.order.payerPostcode = snap.val().postcode
              this.order.payerPhone = snap.val().phone
              this.order.payerEmail = snap.val().receptionEmail || ''
              this.order.payerFax = snap.val().fax
              this.order.payerProvince = snap.val().province
              this.order.payerCountry = snap.val().country
              this.order.sageID = snap.val().sageID
            }
            // this.order.transmitterContact = snap.val().contact
          }).catch(function (error) {
            console.log(error)
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.billingUid) {
              this.order.payerName = entry.name
              this.order.payerAddress = entry.address
              this.order.payerCity = entry.city
              this.order.payerPostcode = entry.postcode
              this.order.payerPhone = entry.phone
              this.order.payerEmail = entry.receptionEmail || ''
              this.order.payerFax = entry.fax
              this.order.payerProvince = entry.province
              this.order.payerCountry = entry.country
              this.order.sageID = entry.sageID
            }
          })
        }
      }
    },
    onInputBillingSame: function () {
      if (this.billingSame) {
        this.order.payerAddress = this.order.receiverAddress
        this.order.payerCity = this.order.receiverCity
        this.order.payerContact = this.order.receiverContact
        this.order.payerFax = this.order.receiverFax
        this.order.payerName = this.order.receiverName
        this.order.payerPhone = this.order.receiverPhone
        this.order.payerEmail = this.order.receiverEmail
        this.order.payerPostcode = this.order.receiverPostcode
        this.order.payerProvince = this.order.receiverProvince
        this.order.payerCountry = this.order.receiverCountry
      }
    },
    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString()
    },
    addOrder: function () {
      var cigle = this.$store.state.userInfo.cigle
      var name = this.$store.state.userInfo.name
      this.order.transpCigle = cigle
      this.order.transpName = name
      this.addCustomer()
      for (var attr in this.order) {
        if (this.order[attr] === undefined) this.order[attr] = ''
      }
      this.vehicles.forEach((element) => {
        this.order.vin = element.vin
        this.order.make = element.make
        this.order.model = element.model
        this.order.year = element.year
        db.ref('test/transporter/' + this.companyUID + '/newDeliveries').push().set(this.order).then(() => {
          // ======================== ADD ORDER LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'ADD_ORDER', 'date': Date.now(), 'targetName': this.order.payerName})
          // ======================== ADD ORDER LOG =======================
        }).catch(function (error) {
          console.log(error)
        })
      })
      this.clear()
      this.closedModal = !this.closedModal
    },
    action: function (order, accept) {
      console.log('action')
      this.inProgress = order['.key']
      var cigle = this.$store.state.userInfo.cigle
      var name = this.$store.state.userInfo.name
      var newPending = JSON.parse(JSON.stringify(order))
      newPending.transpCigle = cigle
      newPending.transpName = name
      if (!accept) newPending.status = 'Cancel'
      else newPending.status = 'Processing'
      var key = newPending['.key']
      delete newPending['.key']
      // console.log(newPending)
      db.ref('test/transporter/' + this.companyUID + '/pendingDeliveries').child(key).set(newPending).then((snapshot) => {
        // ======================== ADD PENDING ORDER ACTION LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': accept ? 'ACCEPTED_PENDING_ORDER' : 'REJECTED_PENDING_ORDER', 'date': Date.now(), 'targetName': order.source})
        // ======================== ADD PENDING ORDER ACTION LOG =======================
        this.inProgress = ''
        this.modal.openPrice = false
      }).catch(function (error) {
        console.log(error)
      })
    },
    openPrice (order) {
      this.modal.openPrice = true
      order.price = ''
      order.datePromis = ''
      this.selected = order
      console.log('open price')
    },
    addVehicle: function () {
      this.vehicles.push({vin: this.VIN, make: this.MAKE, model: this.MODEL, year: this.YEAR})
      this.VIN = ''
      this.MAKE = ''
      this.MODEL = ''
      this.YEAR = ''
    },
    clear: function () {
      for (let attr in this.order) {
        this.order[attr] = ''
      }
      this.order.status = 'Processing'
      this.order.latitude = 0
      this.order.longitude = 0
      this.order.nbDispatch = 0
      for (let attr in this.datalist) {
        this.datalist[attr] = ''
      }
      this.vehicles = []
      this.VIN = ''
      this.MAKE = ''
      this.MODEL = ''
      this.YEAR = ''
    },
    validate: function (vin) {
      // vin test: 1GTR2VE73CZ288102
      console.log(vin)
      window.axios.get('https://dev.transport.keepneye.com/infobemaster/decode/decodevin/' + vin).then((response) => {
        console.log(response)
        this.MAKE = response.data.make
        this.MODEL = response.data.model
        this.YEAR = response.data.year.toString()
      }).catch((error) => console.log(error))
    },
    addCustomer: function () {
      if (this.deliverySave) {
        let savedDelivery = {
          'address': this.order.receiverAddress,
          'city': this.order.receiverCity,
          'contact': this.order.receiverContact,
          'fax': this.order.receiverFax,
          'name': this.order.receiverName,
          'receptionEmail': this.order.receiverEmail,
          'postcode': this.order.receiverPostcode,
          'country': this.order.receiverCountry,
          'province': this.order.receiverProvince,
          'phone': this.order.receiverPhone
        }
        console.log(savedDelivery)
        db.ref('database/transporter/' + this.companyUID + '/carnet').push().set(savedDelivery)
      }
      if (this.pickupSave) {
        let savedPickup = {
          'address': this.order.transmitterAddress,
          'city': this.order.transmitterCity,
          'contact': this.order.transmitterContact,
          'fax': this.order.transmitterFax,
          'name': this.order.transmitterName,
          'receptionEmail': this.order.transmitterEmail,
          'postcode': this.order.transmitterPostcode,
          'country': this.order.transmitterCountry,
          'province': this.order.transmitterProvince,
          'phone': this.order.transmitterPhone
        }
        console.log(savedPickup)
        db.ref('database/transporter/' + this.companyUID + '/carnet').push().set(savedPickup)
      }
    },
    sortBy (criteria, newEntry) {
      if (this.sort.current === criteria && !newEntry) {
        this.sort.desc = !this.sort.desc
      } else if (!newEntry) {
        this.sort.desc = true
        this.sort.current = criteria
      }
      this.filterResults.sort((a, b) => {
        if (a[criteria] === undefined) a[criteria] = ''
        if (b[criteria] === undefined) b[criteria] = ''
        var A = a[criteria]
        var B = b[criteria]
        if (criteria !== 'creationDate' && criteria !== '.key') {
          A = a[criteria].toUpperCase() // ignore upper and lowercase
          B = b[criteria].toUpperCase() // ignore upper and lowercase
        } else {
          A = parseInt(a[criteria])
          B = parseInt(b[criteria])
        }
        if (!this.sort.desc) {
          if (A < B) {
            return -1
          }
          if (A > B) {
            return 1
          }
        } else {
          if (A > B) {
            return -1
          }
          if (A < B) {
            return 1
          }
        }
        // names must be equal
        return 0
      })
    }
  },
  computed: {
    formCompleted: function () {
      return (
        this.vehicles.length !== 0 &&
        this.order.receiverName !== '' &&
        this.order.receiverAddress !== '' &&
        this.order.receiverCountry !== '' &&
        this.order.receiverCity !== '' &&
        this.order.receiverPostcode !== '' &&
        this.order.receiverProvince !== '' &&
        this.order.payerName !== '' &&
        this.order.payerAddress !== '' &&
        this.order.payerCountry !== '' &&
        this.order.payerCity !== '' &&
        this.order.payerPostcode !== '' &&
        this.order.payerProvince !== '' &&
        this.order.transmitterName !== '' &&
        this.order.transmitterAddress !== '' &&
        this.order.transmitterCountry !== '' &&
        this.order.transmitterCity !== '' &&
        this.order.transmitterPostcode !== '' &&
        this.order.transmitterProvince !== '' &&
        ((this.isSageOne && this.order.price !== '') || !this.isSageOne))
    },
    sageOneForm () {
      return ((this.$store.state.userInfo.isSageOne && (this.order.sageID !== '' || this.order.sageID !== undefined) || !this.$store.state.userInfo.isSageOne))
    },
    sageIDonly () {
      return this.addressbook.filter(customer => customer.sageID)
    },
    isSageOne () {
      return this.$store.state.userInfo.isSageOne
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    uid () {
      return this.$store.state.user.uid
    }
  },
  watch: {
    orders: function () {
      // console.log('Processing watcher fired')
      this.filteredSearchMethod()
    },
    billingSame: function (val) {
      if (!val) {
        this.order.payerAddress = ''
        this.order.payerCity = ''
        this.order.payerContact = ''
        this.order.payerFax = ''
        this.order.payerName = ''
        this.order.payerPhone = ''
        this.order.payerEmail = ''
        this.order.payerPostcode = ''
        this.order.payerProvince = ''
        this.order.payerCountry = ''
        this.order.sageID = ''
      } else {
        this.order.payerAddress = this.order.receiverAddress
        this.order.payerCity = this.order.receiverCity
        this.order.payerContact = this.order.receiverContact
        this.order.payerFax = this.order.receiverFax
        this.order.payerName = this.order.receiverName
        this.order.payerPhone = this.order.receiverPhone
        this.order.payerEmail = this.order.receiverEmail
        this.order.payerPostcode = this.order.receiverPostcode
        this.order.payerProvince = this.order.receiverProvince
        this.order.payerCountry = this.order.receiverCountry
        this.order.sageID = this.backup.sageIDDelivery || ''
        this.datalist.billing = ''
        this.datalist.billingUid = ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
input, button{
  cursor: pointer;
}
#addOrder{
  position: relative;
}
#action{
  min-width: 110px;
}
.kne-tab.active{
  color: #f7941e !important;
}
.kne-tab:hover{
  color: #f7941e !important;
}
.view {
  padding-left: 10.5rem;
}
.sidebar {
  width: 10rem
}
</style>



// WEBPACK FOOTER //
// OrderPending.vue?3ed38b24